import { useTranslation } from 'react-i18next';
import { FulfillmentStatus } from '../../models/Order';

export const useFulfillmentStatusLang = (status: FulfillmentStatus) => {
    const { t } = useTranslation();

    let translatedStatus: string | null = null;

    switch (status) {
        case 'fulfilled':
            return (translatedStatus = t('FULFILLMENT_STATUS.FULFILLED'));
        case 'partial':
            return (translatedStatus = t('FULFILLMENT_STATUS.PARTIAL'));
        case 'restocked':
            return (translatedStatus = t('FULFILLMENT_STATUS.RESTOCKED'));
        default:
            return (translatedStatus = t('FULFILLMENT_STATUS.UNFULFILLED'));
    }

    return translatedStatus;
};
